import React from "react";
import JsxSyntaxHighlighter from "../../ui/JsxSyntaxHighlighter";

export default function WithoutReact() {
  return (
    <>
      <p>
        <code>callProFile</code> and <code>processProFileResult</code> can be
        used without React:
      </p>

      <JsxSyntaxHighlighter>
        {`import {defaultConfig, callProFile, processProFileResult} from "@dossier/minibeak";

async function getStatusTableRows() {
  const requestResult = await callProFile({
    ...defaultConfig,
    path:   "/coworkerModuleStatusTableRows",
    include: [
      "employment.person",
      "employment.person.pictureUrl",
      "employment.employmentInfos.employmentPositionTypeNames",
    ],
    queryParams: {
      mode: "MANAGED_COWORKER_DATA",
      offset: 0,
      max: 20,
      includeSubOrgUnits: false,
    },
  });

  const processedResult = processProFileResult(requestResult);

  return processedResult;
}

getStatusTableRows().then((result) => {
  if (result.error) {
    console.log("Error:", result.error)
  }
  else {
    console.log("Data:", result.data);
    console.log("All resources:", result.resources);
    console.log("Response object:", result.response);
  }
})`}
      </JsxSyntaxHighlighter>
    </>
  );
}
